import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  mapWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    maxHeight: '100%',
  },
  mapHidden: {
    display: 'none',
  },
  mapWrapperStoreDetail: {
    position: 'relative',
    top: 'unset',
    bottom: 'unset',
    left: 'unset',
    right: 'unset',
    display: 'flex',
    flexGrow: 1,
    marginBottom: -100,
  },
  mapContainerStyle: {
    width: '100%',
    height: '100%',
  },
  veevaNumber: {
    position: 'absolute',
    bottom: '0.25rem',
    left: '0.25rem',
    color: 'rgba(34, 34, 34, 0.1)',
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
